<pru-modal [modalId]="modalId" [showClose]="loader" size="modal-lg" modalScrollable="true">
  <!-- <div modal-title>
    <h4 class="h3">Link Accounts</h4>
  </div> -->
  <div modal-body *ngIf="showFinAppTool" [attr.data-qa]="'showFinAppTool'">
    <ng-container *ngIf="loader">
      <h2 class="text-center pt-4" [attr.data-qa]="'showFinAppTool_h2'">Please Wait...<span class="fa fa-spinner fa-pulse fa-fw"></span></h2>
    </ng-container>
    <ng-container *ngIf="isModelOpen">
      <pru-finapp-tool
        [hidden]="loader"
        [finAppName]="finAppName"
        [finAppClosed]="finAppClosed"
        [extraParams]="extraParams"
        (doneLoading)="loadingFinAppComplete($event)"
        (syncApiStart)="close($event)"
        (syncApiDone)="close($event)"
        (iFrameActivity)="keepSessionAlive($event)"
        (logoutDone)="hideModalElement($event)"
        (yoodleeError)="handleYoodleeError($event)"
        (closeValuePropModal)="closeModal($event)"
        (showErrorHandlingMsg)="showError($event)"
        (consentAccepted)="consentCheck($event)"
        (showLoadingScreen)="showLoading($event)"
      >
      </pru-finapp-tool>
    </ng-container>
  </div>
  <div modal-footer><a href="javascript:void(0)" class="sr-only" aria-hidden="true">focus trapper</a>
    </div>
</pru-modal>
